async function postJson(path, payload) {
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || 'Request failed');
  }

  return data;
}

export function submitContactForm(payload) {
  return postJson('/api/contact', payload);
}

export function submitInternshipForm(payload) {
  return postJson('/api/internship', payload);
}
